<template>
    <div>
        <modal :show.sync="show_modal" :hide-footer="true">
            <div v-if="approval && approval.approval_type === 'HUB_COMMS_PAYOUT_SUMMARY_APPROVAL'" style="min-width: 500px !important;">
                <div v-if="!is_view_mode">
                    <div class="my-4">
                        <b-form-group label="Reason for Cancel">
                            <b-form-textarea
                                id="textarea"
                                v-model="remark"
                                placeholder="Add a remark"
                                rows="3"
                                max-rows="6"
                            ></b-form-textarea>
                        </b-form-group>
                    </div>
                    <div class="d-flex justify-content-between">
                        <el-button class="bg-success py-2 px-3 text-white" 
                            :loading="is_loading_review"
                            @click="submit(approval, 2, approval.appr_related_id)"
                            ><i class="fa fa-check mr-1"></i>Submit
                        </el-button>
                    </div>
                </div>
            </div>
        </modal>  
    </div>
</template>
<script>
    import { Button } from 'element-ui'
    import { useAuthStore } from '@/stores/authStore'
    import { mapState } from 'pinia'
    import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'

    export default {
        props: ['approval'],
        mixins: [notifyFunctionMixin],
        components: {
            [Button.name]: Button,
        },
        data() {
            return {
                is_loading_review: false,
                show_modal: false,
                remark: '',
                is_view_mode: false,
            }
        },
        methods: {
            toggleView(is_view_mode = null) {
                if(is_view_mode !== null){
                    this.is_view_mode = is_view_mode
                }
                this.show_modal = !this.show_modal;
            },
            submit(approval, val, appr_related_id){
                const reviewer = approval.approval_reviewers[approval.approval_reviewers.length - 1];
                        
                if(reviewer.appr_rev_user_id === this.auth_user.id)
                {
                    swal.fire({
                    title: 'Are you sure?',
                    text: 'Are you sure you want to cancel this case?',
                    icon: 'warning',
                    // showDenyButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Yes!',
                    // denyButtonText: `Don't save`,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            
                            this.is_loading_review = true
                            let data = {
                                'appr_rev_remark': this.remark,
                                'appr_rev_status': val
                            }
                            axios.put(services.approval + 'approval_reviewers/' + reviewer.appr_rev_id, data, {headers: getHeader()})
                                .then(res => {
                                    if(res.status === 200)
                                    {
                                        axios.put(services.hub + 'hub_comms/case_recognize.cancel/' + appr_related_id, {'cancel_reason': this.remark,}, {headers: getHeader()})
                                        .then(res => {
                                            this.remark = ''
                                            this.is_loading_review = false
                                            this.notifySuccess('<b>Approval: - Successfully Rejected.', 2000)
                                            this.notifySuccess('<b>Hub Comms Payout Summary: - Successfully Cancelled.', 2000)
                                            this.$emit('refresh-approval')
                                            this.show_modal = false
                                        })
                                        .catch(e=>{
                                            this.is_loading_review = false
                                            this.errorFunction(e)
                                        })
                                    }
                                })
                                .catch(e=>{
                                    this.is_loading_review = false
                                    this.errorFunction(e)
                                })
                        }
                    })
                }
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user'])
        },
    }
</script>